import styled from 'styled-components';

export const BreakWordWrapper = styled.span({
  wordBreak: 'break-word',
  whiteSpace: 'break-spaces',
});
